/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import wizardStyle from "../../wizardStyle";
import Grid from "@mui/material/Grid";
import { moneyFieldDefault, requiredValidator } from "../../../../services/validationRules";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import FormLegend from "../../Common/FormLegend/FormLegend";

type BankAccountProps = {
  path: string;
  index: number;
};
export default function BankAccount({ path, index }: BankAccountProps) {
  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Daten zum {index + 1}. Konto</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          label="Art des Kontos"
          name={`${path}.type`}
          validators={[requiredValidator("Bitte geben Sie die Kontoart an")]}
          helperText={"Bankkonto, Girokonto, Sparkonto etc."}
        />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField label="Kontoinhaber" name={`${path}.owner`} validators={[requiredValidator("Bitte geben Sie den Kontoinhaber an")]} />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField label="Kreditinstitut" name={`${path}.name`} validators={[requiredValidator("Bitte geben Sie das Kreditinstitut an")]} />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          label="Aktueller Kontostand"
          name={`${path}.amount`}
          validators={[requiredValidator("Bitte geben Sie den Betrag an."), moneyFieldDefault]}
          helperText="Genau dieser Kontostand muss mit einem aktuellen Kontoauszug belegt werden"
        />
      </Grid>
    </>
  );
}
